import React, {useState} from 'react';
import './Contacts.scss';
import DeleteContactsForm from './DeleteContactsForm';
import DeleteGroupContactsForm from './DeleteGroupContactsForm';
import DeleteUserGroupContactsForm from './DeleteUserGroupContactsForm';
import ChangeNameGroupContactsForm from './ChangeNameGroupContactsForm';

import logoGroup from '../../../styles/svg_contacts/groups-contacts.svg';

import logoUserUnconfirmed from '../../../styles/svg_contacts/user-out-button_unconfirmed.svg';
import logoUser from '../../../styles/svg_contacts/user-contact.svg';
import avatar_img from '../../../styles/avatar_default.png';
import { findContact, addContact, addGroupContact, setFindContact,
    addUserGroupContact
} from '../../Authorization/authSlice';
import { openDeleteContactsForm, setSelectedContactId, openDeleteGroupContactsForm, 
    setSelectedGroupContactId, openChangeNameGroupContactsForm, setMessageFindContact, 
    clearMessageFindContact, openDeleteUserGroupContactsForm } from './contactsSlice';
import Config from '../../../config/config';

const Contacts = (props) => {
    const [findNickname, setFindNickname] = useState('');
   // const [valueGroup, setValueGroup] = useState('no group');
    const [selectedNameGroup, setSelectedNameGroup] = useState('');
    const [newGroupName, setNewGroupName] = useState('');
    const [selectedNameGroupForUser, setSelectedNameGroupForUser] = useState('');
    const [selectedIdNameGroupForUser, setSelectedIdNameGroupForUser] = useState();
    const [ addUserToGroup, setAddUserToGroup] = useState(false);
    const [deleteContactId, setDeleteContactId] = useState();

   const {dispatch} = props;

// OPEN DELETE CONTACTS FORM
const onOpenDeleteContactsForm = (e) => {
    

    dispatch(setSelectedContactId(e.target.value));
    dispatch(openDeleteContactsForm());
}
// OPEN DELETE CONTACTS GROUP FORM
const onOpenDeleteContactsGroupForm = (e) => {
    console.log('delete group');

    dispatch(setSelectedGroupContactId(e.target.value));

    dispatch(openDeleteGroupContactsForm());
}
// OPEN DELETE USER FROM CONTACTS GROUP FORM
const onOpenDeleteUserContactsGroupForm = (e) => {
    console.log('delete user from group');

   // dispatch(setSelectedGroupContactId(e.target.value));
    setDeleteContactId(e.target.value);

    dispatch(openDeleteUserGroupContactsForm());
}
// OPEN DELETE CONTACTS GROUP FORM
const onOpenChangeNameContactsGroupForm = (e) => {
    console.log('change name group');

    dispatch(setSelectedGroupContactId(e.target.value));
    dispatch(openChangeNameGroupContactsForm());
}

// RENDER DELETE CONTACT FORM
const renderDeleteContactsForm = () => {
    //const { dispatch } = this.props;
    //dispatch(openClearHistoryForm);
    if (props.contactsStore.openDeleteContactsForm) {
        return (
            <div>
                <DeleteContactsForm
                dispatch={dispatch}
                userId={props.userId}
                contactId={props.contactsStore.selectedContactId}
                
                />
            </div>
        )
     } else return null;
   
   };


   //AVATAR IMAGE
   const serverPath = Config.serverPath;
   const avatarName = props.findContact;
   //console.log(avatarName);
   //const userId = props.findContact[0].id?props.findContact[0].id:null ;
   let avatar_src = avatar_img;
   if (avatarName.length !==0) {
    if (avatarName[0].avatarname)
      avatar_src = `${serverPath}/api/avatar/${avatarName[0].id}/${avatarName[0].avatarname}`;
   }




    //HANDLE FIND CONTACT
    const handleFindContact = (event) => {
        const nickName = event.target.value;
        setFindNickname(nickName);
    }  
    // ONCLICK FIND CONTACT 
    const onClickFindContact =() => {
        // CHECK IF USER ALREADY IN CONTACS
        const checkUser = props.contactsData.findIndex(item => item.nickname === findNickname);
        console.log(props.contactsData);
        console.log(checkUser);
        if (checkUser !== -1) {
            const userData = props.contactsData[checkUser];
            console.log(userData);
            dispatch(setMessageFindContact());
            dispatch(setFindContact(userData));

        } else {
            dispatch(clearMessageFindContact());
            dispatch(findContact(findNickname));
        }

        
    }
    // ONCLICK ADD CONTACT
    const onClickAddContact = () => {

        console.log('Start add contact action');
        if (props.findContact.length !== 0) {
        const data = {
            userId: props.userId,
            contactId: props.findContact[0].id,
        }
        //console.log(data);
        dispatch(addContact(data));
        } else return null;
    }
        //HANDLE ADD NEW GROUP CONTACT
    const handleAddNewGroupContact = (event) => {
        const newGroupName = event.target.value;
        setNewGroupName(newGroupName);
    } 
        // ONCLICK ADD GROUP CONTACT
    const onClickAddGroupContact = () => {

        console.log('Start add group contact action');
        const data = {
            userId: props.userId,
            nameGroup: newGroupName,
        }
        //console.log(data);
        dispatch(addGroupContact(data));
        
    }
   //HANDLE CHOOSE GROUP
   const handleChooseGroup = (e) => {
    const nameGroup = e.target.value;
    setSelectedNameGroup(nameGroup);
    const groupId = Number(e.target.dataset.value1);
    dispatch(setSelectedGroupContactId(groupId));
   };

   //ADD USER TO GROUP
   const onClickAddContactToGroup = () => {
    const data = {
        userId: props.findContact[0].id,
        groupId: selectedIdNameGroupForUser,
    }
    dispatch(addUserGroupContact(data));

   }



   //RENDER GROUPS -NO ACTIVE BEFORE DEVELOPE
   
    const renderGroups = () => {
        let data = props.contactsGroupsData;
        console.log(data);
        return (
            data.map((item, index) => {
                return (
                    <tr key={index}>
                        <td className='td-count'>{index+1}.</td>
                        <td>
                            <img src={logoGroup} alt='logo'/>
                        </td>
                        <td>
                            <button className={item.groupName === selectedNameGroup ?'button-group-selected':'button-group'} 
                            value ={item.groupName} data-value1={item.id} onClick={handleChooseGroup}>
                                {item.groupName}
                            </button>
                        </td>
                        <td>
                            <button className='edit' value={item.id} onClick={onOpenChangeNameContactsGroupForm}></button>
                        </td>
                        <td>
                            <button className='delete' value={item.id} onClick={onOpenDeleteContactsGroupForm}></button>
                        </td>
                    </tr>               
                    )
            }

            )
        );
        

    }
    //RENDER OPTIONS FOR GROUP ADD USER
       const renderOptionsGroup = () => {
        let data = props.contactsGroupsData;
        console.log(data);
        return (
            data.map((item, index) => {
                return (
                    <option key={index} value={item.id} >{item.groupName}</option>
                    )
            }

            )
        );
    } 
        //HANDLE ID OCCUPATION
    const handleChooseOptionsGroup= (event) => {
        console.log(event);
        const selectedName =event.target.options[event.target.selectedIndex].text;
        console.log(selectedName);
        setSelectedNameGroupForUser(selectedName);         
        const selectedGroupId =Number(event.target.options[event.target.selectedIndex].value);
        console.log(selectedGroupId);
        console.log(event.target.selectedIndex);
        //console.log(event.target.options[0].value);
        setSelectedIdNameGroupForUser(selectedGroupId);
       
    }
    //HANDLE ADD USER CHECKBOX
    const handleAddUserCheckbox = () => {
        
            setAddUserToGroup(!addUserToGroup);
        
        
    }

   //RENDER USERS
   const renderContacts = () => {
    let data = props.contactsData;
    //console.log(data);




    if (data) {
        return (
        data.map((item, index) => {

           // let styleDisabled;
            let logoUserContact;
            let mesConfirmed;
            if (item.confirmed) {
          
                //styleDisabled = '';
                logoUserContact = logoUser;
                mesConfirmed =  '';
            } else {
               // styleDisabled = 'disabled';
                logoUserContact = logoUserUnconfirmed;
                mesConfirmed = 'не подтвержден'
                
            }

            let avatarName= item.avatarname;
           // console.log(avatarName);
            //const userId = props.findContact[0].id?props.findContact[0].id:null ;
            let avatar_src = avatar_img;
            if (avatarName) {
                avatar_src = `${serverPath}/api/avatar/${item.id}/${item.avatarname}`;
            }
           
            return (
                <tr key={index}>
                    <td>{index+1}.</td>
                    <td>
                        <img src={logoUserContact} alt='logo'/>
                    </td>
                    <td>
                        <button className='button-users'>
                           {item.username} ({item.nickname})
                        </button>
                    </td>
                    <td>
                        <img src={avatar_src} alt="Avatar" className='avatar-contact'/>
                    </td>
                    <td>
                        <button className='user-out-button' value={item.id} onClick={onOpenDeleteContactsForm}></button>
                    </td>
                    <td>
                        <p className='p-confirmed'>{mesConfirmed}</p>
                    </td>
                   
                </tr>
                             
                )
        }

        )
    );
    
    } else return null;
    }

   //RENDER USERS OF THE GROUP -NO ACTIVE BEFORE DEVELOP
   
   const renderMembersGroup = () => {

    let indexSelectedGroup = props.contactsGroupsData.findIndex(item => item.groupName === selectedNameGroup);

    if (indexSelectedGroup !== -1) {
    let data = props.contactsGroupsData[indexSelectedGroup].contacts;
    console.log(data);
    return (
        data.map((item, index) => {
            let avatarName= item.avatarname;

            let avatar_src = avatar_img;
            if (avatarName) {
                avatar_src = `${serverPath}/api/avatar/${item.id}/${item.avatarname}`;
            }
            return (
                <tr key={item.nickname}>
                    <td>{index+1}.</td>
                    <td>
                        <img src={logoUser} alt='logo'/>
                    </td>
                    <td>
                        <button className='button-users'>
                            {item.username}({item.nickname})
                        </button>
                    </td>
                    <td>
                        <img src={avatar_src} alt="Avatar" className='avatar-contact'/>
                    </td>
                    <td>
                        <button className='user-out-button' value={item.id} onClick={onOpenDeleteUserContactsGroupForm}></button>
                    </td>
                   
                   
                </tr>               
                )
        }

        )
    );
    } else return null;
    

}
    
   //RENDER RESULT OF SEARCHING USERS
   const renderResultSearchUser = () => {
    let data = props.findContact;
   // console.log(data);
    if (data.length !==0) {
        return (
             
            <tr>
                <td>
                    <img src={logoUser} alt='logo'/>
                </td>
                <td>
                    <button className='button-users'>
                        {data[0].username}({data[0].nickname})
                    </button>
                </td>
                <td>
                    <img src={avatar_src} alt="Avatar" className='avatar-contact'/>
                </td>
                <td><p className='search-message'>{props.contactsStore.messageFindContact}</p></td>

            </tr>               
            
    
    
);
    } else return (
        <tr>
            <td > <p className='p-main'>
            Пользователь не найден.
                </p>
            </td>
        </tr>
    );

    

}


//RENDER ALL
 const contactsView = props.contactsView;
 if (contactsView) {
    return (
        <div className='Contacts'>
            <p className='main-header'> Контакты</p>
            <div className='main-container'>
                <div className='header'>
                    <p className='p-header'>Группы</p>
                </div>
            
                <div className='container'>
                    
                    <div className='groups-block'>
                      <div className='container-column'> 
                            <div className='table-div'>
                                <table>
                                    <tbody>
                                    {renderGroups()}
                                    </tbody>
                                </table>
                            </div>
                            <p className='p-main'>Добавить новую группу</p>
                            <div className="searcher-user">
                                <input type="text" placeholder="имя группы" onChange={handleAddNewGroupContact}/>
                                <p className='error-message'>{props.errorMessageGroupContact}</p>
                                <button className='common-button' onClick={onClickAddGroupContact}>Добавить</button> 
                            </div>
                      </div>   
                    </div>
                    <div className='groups-right'>
                        <div className='header-group-content'>
                            <img  className='image-group' src = {logoGroup} alt='logogroup' />
                            <p className='p-main'>Состав группы  - {selectedNameGroup ? selectedNameGroup : null}:</p>
                        </div>
                        
                        <div className='table-div'>
                            <table>
                                <tbody>
                                    {renderMembersGroup()}
                                    </tbody>
                                </table>
                                            

                        </div>
                         
                    </div>
                    
                    </div>
               
                <div className='header'>
                    <p className='p-header'>Пользователи</p>
                </div>
                
                <div className='container'>
                    
                     <div className='groups'>
                        <div className='table-div'>
                                <table>
                                    <tbody>
                                    {renderContacts()}
                                    </tbody>
                                </table>
                            </div>
                     </div>
                     <div className='groups-right-search'>
                        <p className='p-main'>Найти пользователя по nickname</p>
                        <div className="searcher-user">
                             <input type="text" placeholder="nickname" onChange={handleFindContact} />
                             <button className='common-button' onClick={onClickFindContact}>Найти</button> 
                        </div>
                         
                         <div className='table-div-search'>
                                <table>
                                    <tbody>
                                    {renderResultSearchUser()}
                                    </tbody>
                                </table>
                                <button className='common-button' onClick={onClickAddContact} >Добавить</button> 
                        </div>
                         
                         <div className='container-column'>
                            <label htmlFor='finduser'>Добавить найденного пользователя в группу </label>
                            <input className="checkbox" name="finduser" type='checkbox' onChange = {handleAddUserCheckbox} disabled ={findNickname.length!==0 ? '' : 'disabled'} />
                            <input  placeholder={props.findContact.length !==0 ? `${props.findContact[0].username}(${props.findContact[0].nickname})` :'user name/nickname'} disabled></input>
                             <label htmlFor='groups'>Выбрать группу </label>
                            <select name="groups" defaultValue={'Default'} value={selectedIdNameGroupForUser} onChange={handleChooseOptionsGroup} disabled ={findNickname.length!==0 ? '' : 'disabled'}>
                                <option disabled  value="Default"></option>
                                {renderOptionsGroup()}

                            </select>
                            <input  placeholder={selectedNameGroupForUser} disabled></input>
                            <button className='common-button' onClick= {onClickAddContactToGroup} disabled ={findNickname.length!==0 ? '' : 'disabled'}>Добавить</button>
                            <p className='error-message'>{props.errorMessageUserGroupContact}</p>
                         </div>
                             
                     </div>
                </div>
            </div>
            {renderDeleteContactsForm()}
            {props.contactsStore.openDeleteGroupContactsForm ? <DeleteGroupContactsForm
                dispatch={dispatch}
                
                groupId={props.contactsStore.selectedGroupContactId}
            /> : null}
             {props.contactsStore.openDeleteUserGroupContactsForm ? <DeleteUserGroupContactsForm
                dispatch={dispatch}
                userId={deleteContactId}
                groupId={props.contactsStore.selectedGroupContactId}
            /> : null}
            {props.contactsStore.openChangeNameGroupContactsForm ? <ChangeNameGroupContactsForm
                dispatch={dispatch}
                
                groupId={props.contactsStore.selectedGroupContactId}
            /> : null}

        </div>
    )
 }   
};

export default Contacts;